import api from '@/api';
import { api as apiV2 } from '@/api/api.v2';

export const techOrder = ['tech_columns', 'tech_cement', 'tech_bridges'];

export const techModel = {
    state: {
        data: {},
        error: false,
        loading: false,
    },
    reducers: {
        // Remove
        setTech: (state, payload) => {
            return { ...state, data: { ...state.data, [payload.id]: payload.data } };
        },
        setError: (state, payload) => {
            return { ...state, error: payload };
        },
    },
    effects: dispatch => ({
        async loadTech(wellId, rootState) {
            this.loading = true;

            try {
                const section = await api.carottage.fetchSectionCasing({ wellIds: [wellId] });
                const cement = await api.carottage.fetchCementLogging({ wellIds: [wellId] });
                let isolation = rootState.tablets.isGroup
                    ? rootState.tablets.list[rootState.tablets.activeGroupName][wellId]?.wellServices?.isolation
                    : rootState.tablets.list[wellId]?.wellServices?.isolation;
                if (!isolation) {
                    const response = await apiV2.carottage.fetchGraphData(wellId, JSON.stringify(['isolation']));
                    isolation = response.isolation;
                }
                const drill = await api.carottage.fetchDrilling({ wellIds: [wellId] });
                const res = {};

                if (drill?.length > 0) {
                    res.lastDrill = drill.reduce(
                        (prev, cur) => {
                            if (cur.end_date) {
                                const curDate = new Date(cur.end_date);
                                if (!prev || prev < curDate) {
                                    return curDate;
                                }
                            }
                            return prev;
                        },
                        drill[0].end_date ? new Date(drill[0].end_date) : '',
                    );
                    if (res.lastDrill) res.lastDrill = res.lastDrill.toLocaleDateString();
                } else {
                    res.lastDrill = '';
                }

                if (Array.isArray(section) && section.length > 0) {
                    res.construct = section.map(sec => ({
                        id: sec.id,
                        top_depth: sec.top_depth,
                        bottom_depth: sec.bottom_depth,
                        inner_diameter: sec.inner_diameter,
                        outer_diameter: sec.outer_diameter,
                    }));
                    res.lastColumnOuterDiameter = section.reduce(
                        (prev, cur) => (prev > cur.outer_diameter ? cur.outer_diameter : prev),
                        section[0].outer_diameter,
                    );
                } else {
                    res.construct = [];
                }

                const DIAMETER_EPSILON = 15;
                const getCementType = descr => {
                    if (typeof descr === 'string') {
                        if (descr.toLowerCase().includes('сплошн')) {
                            return 'СПЛОШНОЙ';
                        }
                        if (descr.toLowerCase().includes('хорош')) {
                            return 'ХОРОШЕЕ';
                        }
                        if (descr.toLowerCase().includes('частичн')) {
                            return 'ЧАСТИЧНЫЙ';
                        }
                        if (descr.toLowerCase().includes('отсутств')) {
                            return 'ОТСУТСТВУЕТ';
                        }
                        return 'НЕТ ДАННЫХ';
                    }
                    return 'НЕТ ДАННЫХ';
                };

                if (Array.isArray(cement) && cement.length > 0) {
                    res.cement = cement
                        .map(cem => {
                            const nearColumn = res.construct.find(
                                con => Math.abs(con.inner_diameter - 1000 * cem.KOLON_DIAM) < DIAMETER_EPSILON,
                            );
                            if (nearColumn) {
                                return {
                                    construct_id: nearColumn.id,
                                    min: cem.TOP_DEPTH,
                                    max: cem.BASE_DEPTH,
                                    type: getCementType(cem.CONTACT_KOLON),
                                    message: cem.CONTACT_KOLON,
                                };
                            } else {
                                return null;
                            }
                        })
                        .filter(e => e !== null);
                } else {
                    res.cement = [];
                }

                if (isolation && Object.values(isolation)?.length > 0) {
                    res.bridges = Object.values(isolation).flatMap(isoArray =>
                        isoArray.map(iso => {
                            const tooltipCreateDate = `<br/>Дата установки: ${iso.dateTime ? iso.dateTime : 'нет'}`;
                            const tooltipDrillDate = `<br/>Дата повторного разбуривания: ${
                                iso.drillDate ? iso.drillDate : 'нет'
                            }`;

                            const tooltipTop = `<br/>Глубина кровли: ${iso?.roof?.toFixed(0)} м.`;
                            const tooltipBottom = `<br/>Глубина подошвы: ${iso?.bottom?.toFixed(0)} м.`;
                            const tooltipTopDrill = `<br/>Разбур. кровли: ${
                                iso.topDepthDrill !== null && iso.topDepthDrill !== undefined
                                    ? `${Number(iso.topDepthDrill).toFixed(0)} м.`
                                    : 'нет'
                            }`;
                            const tooltipBottomDrill = `<br/>Разбур. подошвы: ${
                                iso.baseDepthDrill !== null && iso.baseDepthDrill !== undefined
                                    ? `${Number(iso.baseDepthDrill).toFixed(0)} м.`
                                    : 'нет'
                            }`;

                            const isoType = iso.drillDate ? 'Разбур.' : 'Устан.';

                            return {
                                min: iso?.roof,
                                topDepthDrill: iso?.topDepthDrill,
                                max: iso?.bottom,
                                date: iso.dateTime,
                                type: isoType,
                                tooltip: `<b>Параметры цементного моста</b>${tooltipCreateDate}${tooltipDrillDate}${tooltipTop}${tooltipBottom}${tooltipTopDrill}${tooltipBottomDrill}`,
                            };
                        }),
                    );
                } else {
                    res.bridges = [];
                }

                // считаем макс и мин высоту
                res.max =
                    res.construct.length > 0
                        ? res.construct.reduce(
                              (prev, cur) => (prev < cur.bottom_depth ? cur.bottom_depth : prev),
                              res.construct[0].bottom_depth,
                          )
                        : 0;
                res.min =
                    res.construct.length > 0
                        ? res.construct.reduce(
                              (prev, cur) => (prev > cur.top_depth ? cur.top_depth : prev),
                              res.construct[0].top_depth,
                          )
                        : 0;

                res.maxDrillers =
                    drill.length > 0
                        ? drill.reduce((prev, cur) => (prev > cur.drillers ? cur.drillers : prev), drill[0].drillers)
                        : 0;

                this.setTech({ id: wellId, data: res });
                this.loading = false;
            } catch (error) {
                this.setError(error);
                this.loading = false;
                console.log(error);
            }
        },
    }),
};
